<template>
  <div class="expand-tab">
    <div class="expand-tab__header" @click="isOpened = !isOpened">
      <div class="expand-tab__header__icon">
        <i class="mdi" :class="`mdi-chevron-${isOpened ? 'up' : 'down'}`"></i>
      </div>
      <div class="expand-tab__header__title">
        <span v-if="!$slots.title">
          {{ title }}
        </span>
        <slot name="title" :title="title" />
      </div>
    </div>
    <div class="expand-tab__content" v-show="isOpened">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpandTab',
  props: {
    title: String,
  },
  data() {
    return {
      isOpened: false,
    };
  },
};
</script>

<style lang="scss">
.expand-tab {
  &__content {
    padding-right: 24px;
    padding-left: 24px;
  }
  &__header {
    display: flex;
    cursor: pointer;
    padding-top: 7px;
    padding-bottom: 7px;
    &__icon {
      margin-right: 12px;
    }
    &__title {
      font-size: 14px;
      color: #333333;
      font-weight: 600;
    }
  }
}
</style>
